<template>
  <Navbar regloginpass logourl="/rental" />

  <section id="registrationConfirmInfo">
    <div class="container pt-5">
      <div class="section-caption">
        <h2>Rejestracja</h2>
      </div>
      <div class="tile">
        <div class="section-content">
          <Alert
            v-if="registrationConfirmed"
            alert-type="alert-success"
            alert-text="Potwierdzenie rejestracji zakończone powodzeniem. Za chwilę nastąpi automatyczne logowanie do konta użytkownika."
          />
          <Alert
            v-if="registrationNotConfirmed"
            alert-type="alert-danger"
            alert-text="Potwierdzenie rejestracji zakończone niepowodzeniem. Skontaktuj się z pomocą techniczną."
          />
          <Alert
            v-if="registrationAlreadyConfirmed"
            alert-type="alert-info"
            alert-text="Rejestracja została już wcześniej potwierdzona. Możesz się zalogować używając nazwy użytkownika i hasła podanego przy rejestracji."
          />
          <div class="text-center">
            <button class="btn-standard" @click="onMainPageButtonClick">
              Zaloguj
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Stopka -->
  <Footer />
</template>

<script>
import { RequestResult } from "@/utils/requestResult";
import { makeRequest, scrollToTop } from "@/utils/helpers";
import Alert from "@/components/Alert.vue";
import Footer from "@/components/Footer.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  name: "RegistrationConfirmView",
  components: { Navbar, Footer, Alert },

  data() {
    return {
      registrationConfirmed: false,
      registrationNotConfirmed: false,
      registrationAlreadyConfirmed: false,

      rentalAPIUrl: window.location.origin + "/rental/api/", // na develop mode 127.0.0.1/rental/api/
    };
  },

  async created() {
    scrollToTop();

    let uuid = this.$route.params.uuid;
    await this.registrationConfirm(uuid);
  },

  methods: {
    onMainPageButtonClick() {
      this.$router.push(this.routePath.Login);
    },

    async registrationConfirm(uuid) {
      this.registrationConfirmed = false;
      this.registrationNotConfirmed = false;
      this.registrationAlreadyConfirmed = false;

      let data = {
        action: this.request.ConfirmRegistration,
        uuid: uuid,
      };

      let registrationConfirmRequestResponse = await makeRequest(
        data,
        "POST",
        this.rentalAPIUrl
      );

      switch (registrationConfirmRequestResponse.data.error) {
        case RequestResult.OK: {
          this.registrationConfirmed = true;
          setTimeout(() => {
            this.login(uuid);
          }, 3000);

          break;
        }
        case RequestResult.GeneralError: {
          this.registrationNotConfirmed = true;
          break;
        }
        case RequestResult.UserRegAlreadyConfirmed: {
          this.registrationAlreadyConfirmed = true;
          break;
        }
      }
    },

    async login(uuid) {
      let data = {
        action: this.request.LoginByUUID,
        uuid: uuid,
      };

      let loginByUUIDRequestResponse = await makeRequest(
        data,
        "POST",
        this.rentalAPIUrl
      );

      switch (loginByUUIDRequestResponse.data.error) {
        case RequestResult.OK: {
          this.$router.push(this.routePath.SubscriptionHandle);
          break;
        }
        case RequestResult.GeneralError:
        case RequestResult.InvalidCookie:
        case RequestResult.CookieExpired: {
          // wyloguj
          // wróć do strony głównej
          this.$router.push(this.routePath.Login); // to pewnie się jeszcze zmieni
          break;
        }
      }
    },
  },
};
</script>

<style scoped></style>
